goog.provide("shadow.js.shim.module$src$svg$weather$cloud_svg");
goog.provide("module$shadow_js_shim_module$src$svg$weather$cloud_svg");
shadow.js.shim.module$src$svg$weather$cloud_svg = shadow.js.nativeProvides["src/svg/weather/cloud.svg"] = shadow$bridge("src/svg/weather/cloud.svg");
module$shadow_js_shim_module$src$svg$weather$cloud_svg.default = shadow.js.shim.module$src$svg$weather$cloud_svg;
